import { createAction, createAsyncActions } from './utils'

const reducer = 'USERS'

const saveLastUrl = createAction(reducer, 'SAVE_LAST_URL')
const setDeviceType = createAction(reducer, 'SET_DEVICE_TYPE')
const setWindowWidth = createAction(reducer, 'SET_WIDTH')

const {
  action: initializeSession,
  actionSuccess: initializeSessionSuccess,
  actionFail: initializeSessionFail
} = createAsyncActions(reducer, 'INITIALIZE_SESSION')

const rerouteSession = createAction(reducer, 'REROUTE_SESSION')

const {
  action: login,
  actionSuccess: loginSuccess,
  actionFail: loginFail
} = createAsyncActions(reducer, 'LOGIN')

const {
  action: resendActivationEmail,
  actionSuccess: resendActivationEmailSuccess,
  actionFail: resendActivationEmailFail
} = createAsyncActions(reducer, 'RESEND_ACTIVATION_EMAIL')

const {
  action: logout,
  actionSuccess: logoutSuccess,
  actionFail: logoutFail
} = createAsyncActions(reducer, 'LOGOUT')

const {
  action: signup,
  actionSuccess: signupSuccess,
  actionFail: signupFail
} = createAsyncActions(reducer, 'SIGNUP')

const {
  action: getUser,
  actionSuccess: getUserSuccess,
  actionFail: getUserFail
} = createAsyncActions(reducer, 'GET')

const {
  action: getCurrentUser,
  actionSuccess: getCurrentUserSuccess,
  actionFail: getCurrentUserFail
} = createAsyncActions(reducer, 'GET_CURRENT_USER')

const {
  action: listUsers,
  actionSuccess: listUsersSuccess,
  actionFail: listUsersFail
} = createAsyncActions(reducer, 'LIST_USERS')

const {
  action: updateUserInformation,
  actionSuccess: updateUserInformationSuccess,
  actionFail: updateUserInformationFail
} = createAsyncActions(reducer, 'UPDATE_USER_INFORMATION')

const {
  action: updateUser,
  actionSuccess: updateUserSuccess,
  actionFail: updateUserFail
} = createAsyncActions(reducer, 'UPDATE_USER')

const {
  action: changePassword,
  actionSuccess: changePasswordSuccess,
  actionFail: changePasswordFail
} = createAsyncActions(reducer, 'CHANGE_PASSWORD')

const {
  action: sendPasswordResetCode,
  actionSuccess: sendPasswordResetCodeSuccess,
  actionFail: sendPasswordResetCodeFail
} = createAsyncActions(reducer, 'SEND_PASSWORD_RESET_CODE')

const {
  action: confirmPasswordReset,
  actionSuccess: confirmPasswordResetSuccess,
  actionFail: confirmPasswordResetFail
} = createAsyncActions(reducer, 'CONFIRM_PASSWORD_RESET')

/** no action, we don't want to be able to dispatch from redux-devtools */
const {
  actionSuccess: signupOnApartmentConfirmationSuccess,
  actionFail: signupOnApartmentConfirmationFail
} = createAsyncActions(reducer, 'SIGNUP_ON_APARTMENT_CONFIRMATION')

export {
  setDeviceType,
  setWindowWidth,
  initializeSession,
  initializeSessionSuccess,
  initializeSessionFail,
  rerouteSession,
  login,
  loginSuccess,
  loginFail,
  resendActivationEmail,
  resendActivationEmailSuccess,
  resendActivationEmailFail,
  logout,
  logoutSuccess,
  logoutFail,
  signup,
  signupSuccess,
  signupFail,
  getUser,
  getUserSuccess,
  getUserFail,
  getCurrentUser,
  getCurrentUserSuccess,
  getCurrentUserFail,
  listUsers,
  listUsersSuccess,
  listUsersFail,
  updateUserInformation,
  updateUserInformationSuccess,
  updateUserInformationFail,
  updateUser,
  updateUserSuccess,
  updateUserFail,
  changePassword,
  changePasswordSuccess,
  changePasswordFail,
  sendPasswordResetCode,
  sendPasswordResetCodeSuccess,
  sendPasswordResetCodeFail,
  confirmPasswordReset,
  confirmPasswordResetSuccess,
  confirmPasswordResetFail,
  saveLastUrl,
  signupOnApartmentConfirmationSuccess,
  signupOnApartmentConfirmationFail
}
